import { buildStaffMenu } from "./staffMenu"
// Also available for Call Centre-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Call Centre role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Call Centre-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildCallCentreMenu = () => buildStaffMenu()
